import { Box, Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router';
import Text from '../../shared/Text';
import CommonStaticLayout from './common-static-layout';

const SupportSsoError: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  return (
    <CommonStaticLayout>
      <Box display="flex" flexDirection="column" gap="16px">
        <Typography variant="h1">
          <strong>{Text.get('support_sso_error_title')}</strong>
        </Typography>
        <Typography variant="body1">
          {params.get('error_description') || Text.get('unexpected_error')}
        </Typography>
      </Box>
    </CommonStaticLayout>
  );
};

export default SupportSsoError;
